import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { UserRole } from "src/util/types/dataModels/user"

//region Types

export type UserRoleDocument = RxDocument<UserRole>
export type UserRoleCollection = RxCollection<UserRole>

//endregion

/**
 * Schema for user roles collections
 */
export const userRoleSchema: RxJsonSchema<UserRole> = {
  title: "User Role schema",
  description: "Collection of all user roles",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true }, // UUID

    name: { type: "string", minLength: 1, maxLength: 128 },

    organisation: { type: "string", maxLength: 36 }, // UUID

    service_provider: { type: "string", maxLength: 36 }, // UUID

    workspaces: {
      type: "array",
      items: {
        ref: "workspace",
        type: "string",
        maxLength: 36,
      },
    },

    work_domains: {
      type: "array",
      items: {
        ref: "work_domain_global",
        type: "string",
        maxLength: 36,
      },
    },
  },
  required: ["id", "name"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const userRoleCollectionCreator: RxCollectionCreator = {
  schema: userRoleSchema,
}
